import React, { useEffect, useState } from "react"
import SettingSection from "./setting-section"
import { User } from "lucide-react"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { useTranslation } from "react-i18next"
import { LoadingOverlay, Switch } from "@mantine/core"
import ToggleSwitch from "./toggle-switch"
import { useLazyGetOwnerQuery } from "../../owner/store/owner.query"
import { useToggleConfidentialityMutation } from "../store/settings.query"

const Profile = () => {
  const [userinfo, userId, ownerInfo] = useCurrentUser()
  const { t } = useTranslation()
  const [getOwner, owner] = useLazyGetOwnerQuery()
  const [confidential, setConfidential] = useState<boolean>(false)
  const [toggleConfidentiality, toggleConfidentialityResponse] =
    useToggleConfidentialityMutation()
  useEffect(() => {
    if (userinfo?.role?.key === "owner") {
      getOwner(userinfo?.id as string)
    }
  }, [userinfo?.id])

  useEffect(() => {
    setConfidential(owner?.data?.confidential as boolean)
  }, [owner, getOwner])
  return (
    <SettingSection
      icon={User}
      title={t("profile")}
      heading={
        userinfo?.role?.key == "owner" &&
        ownerInfo?.id == ownerInfo?.parentOwnerId ? (
          <div className="flex flex-col md:flex-row justify-between items-center">
            <LoadingOverlay visible={toggleConfidentialityResponse.isLoading} />
            <div className="flex items-center mb-4">
              <User className="text-indigo-400 mr-4" size={24} />
              <h2 className="text-xl font-semibold text-gray-100">
                {t("profile")}
              </h2>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <ToggleSwitch
                label={"Toggle Confidentiality"}
                isOn={confidential}
                onToggle={() => {
                  toggleConfidentiality(userinfo?.id).then((response) =>
                    setConfidential((prev) => !prev),
                  )
                }}
              />
            </div>
          </div>
        ) : null
      }
    >
      <div className="flex flex-col sm:flex-row items-center mb-6">
        <img
          src={"https://staking.voi.network/happy.png"}
          alt="Profile"
          className="rounded-full w-20 h-20 object-cover mr-4"
        />

        <div>
          <h3 className="text-lg font-semibold text-gray-100">
            {" "}
            {userinfo?.name}
          </h3>
          <p className="text-gray-400 text-xs">{userinfo?.role?.name}</p>
          <p className="text-gray-400">{userinfo?.email}</p>
        </div>
      </div>
      {/* <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded transition duration-200 w-full sm:w-auto">
                    Edit Profile
                </button> */}
    </SettingSection>
  )
}

export default Profile
